import React, { useRef, useState } from 'react'
import { Manager, Popper, Reference } from 'react-popper'

import { ButtonClean, InputUI, VisuallyHidden, useOutsideClick } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import { SideSummary } from '../../../../../../../components/common/SideSummary'
import { TimezonedCalendar } from '../../../../../../Timezone/components/TimezonedCalendar'
import type { FormValues } from '../../types'
import { FormFields } from '../../types'

export const PostPublishedDate = () => {
  const { values, setFieldValue, errors } = useFormikContext<FormValues>()
  const containerRef = useRef<HTMLDivElement>(null)
  const [isOpen, setOpen] = useState(false)
  const toggleOpen = () => {
    setOpen((prevIsOpen) => !prevIsOpen)
  }

  useOutsideClick(containerRef, () => {
    setOpen(false)
  })

  if (values.postType === 'LiveStream') return null

  return (
    <SideSummary.Item title="Published date">
      <TimezonedDateString
        date={values.liveAt || new Date()}
        format="MMM DD, YYYY, hh:mm A"
        withTimezoneAbbreviation={false}
      />
      <Manager>
        {/* NOTE: Hack to focus whole section on submit with error */}
        <VisuallyHidden>
          <input type="text" name={FormFields.liveAt} />
        </VisuallyHidden>
        <div ref={containerRef}>
          <Reference>
            {({ ref }) => (
              <div ref={ref}>
                <ButtonClean label="Edit" onClick={toggleOpen} />
              </div>
            )}
          </Reference>
          {isOpen && (
            <Popper placement="bottom-end">
              {({ ref, style }) => (
                <div ref={ref} style={{ ...style, paddingTop: 8, zIndex: 1 }}>
                  <TimezonedCalendar
                    type="single"
                    selectedDates={values.liveAt ? [values.liveAt] : []}
                    onDatesChange={([date]) => {
                      setFieldValue('liveAt', date)
                    }}
                    timeLabels={['Publish time']}
                    maxDate={values[FormFields.mode] === 'update' ? new Date() : undefined}
                  />
                </div>
              )}
            </Popper>
          )}
        </div>
      </Manager>
      {errors.liveAt && <InputUI.Error>{errors.liveAt}</InputUI.Error>}
    </SideSummary.Item>
  )
}
